"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getHstc = getHstc;
exports.getUtk = getUtk;
exports.set = exports.get = void 0;

var _cookies = require("hub-http/helpers/cookies");

var _storageKeys = require("usage-tracker-core/storageKeys");

var get = function get(key) {
  return (0, _cookies.getCookie)(key, document.cookie);
};

exports.get = get;

var set = function set(key, value) {
  var expiresInMillis = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 60 * 24 * 60 * 60 * 1000;
  var currentTime = new Date();
  var expiryTime = new Date(currentTime.setTime(currentTime.getTime() + expiresInMillis)).toUTCString();
  document.cookie = key + "=" + value + ";expires=" + expiryTime + ";path=/";
};

exports.set = set;

function getHstc() {
  return get(_storageKeys.hstcKey) || null;
}

function getUtk() {
  var utk = get('hubspotutk');

  if (!utk) {
    utk = getHstc();

    if (utk) {
      utk = utk.split('.')[1];
    }
  }

  return utk || null;
}


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/usage-tracker-public/static-1.325/js/helpers/cookieHelper.js
// module id = 902
// module chunks = 6